import React, { useState, useEffect, useCallback } from 'react';
import SideBar from './SideBar';
import TopBar from './TopBar';
import AssignmentAlerts from './AssignmentAlerts/AssignmentAlerts';
import { MessageToastHost } from './MessageNotifications';
import './Layout.css';

const contentAreaStyle = { marginTop: '-30px' };

const Layout = ({ children, pageTitle = '' }) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Listen for window resize events to detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileSidebarOpen(false);
      }
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleMobileSidebar = useCallback(() => {
    setMobileSidebarOpen((prev) => !prev);
  }, []);

  const handleSidebarCollapse = useCallback((collapsed) => {
    setIsCollapsed(collapsed);
  }, []);

  return (
    <div className="layout-container">
      {/* Pass 'active' prop to control mobile sidebar visibility */}
      <SideBar 
        active={mobileSidebarOpen} 
        onCollapse={handleSidebarCollapse}
      />
      
      <div className={`main-content ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
        <TopBar 
          pageTitle={pageTitle} 
          onToggleSidebar={toggleMobileSidebar} 
          isMobile={isMobile} 
        />
        <div className="content-area" style={contentAreaStyle}>
          {/* Son tamamlama tarihi yaklaşan atamalar için kırmızı uyarı bandı ve
              girişte bir kez çıkan okunmamış SOP hatırlatması */}
          <AssignmentAlerts />
          {children}
        </div>
      </div>

      {/* Gelen mesaj kartları: kullanıcı hangi sayfada olursa olsun görünür */}
      <MessageToastHost />
    </div>
  );
};

export default Layout;
